import { yandexMetric } from '@affine/track';
import { useLayoutEffect } from 'react';

export const YandexMetricProvider = () => {
  useLayoutEffect(() => {
    yandexMetric.init(runtimeEnv.DNB_YANDEX_METRIC);
    return () => {
      yandexMetric.remove();
    };
  }, []);

  return null;
};
